import { render, staticRenderFns } from "./ModalForm.vue?vue&type=template&id=1a7b613e&scoped=true&"
import script from "./ModalForm.vue?vue&type=script&lang=js&"
export * from "./ModalForm.vue?vue&type=script&lang=js&"
import style0 from "./ModalForm.vue?vue&type=style&index=0&id=1a7b613e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a7b613e",
  null
  
)

export default component.exports